import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { ChevronDownIcon } from './icons';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  invalid?: boolean;
}

/**
 * A native <select> with our chrome. Native on purpose: iOS renders it as the
 * system wheel picker, which is faster to use one-handed on a phone than
 * anything we would build, and it works with no JavaScript for the currency
 * list — the one control on the expense form nobody should have to think about.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, style, children, ...rest },
  ref,
) {
  return (
    <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
      <select
        {...rest}
        ref={ref}
        aria-invalid={invalid || undefined}
        style={{
          width: '100%',
          minHeight: 44,
          padding: '0 34px 0 var(--sp-4)',
          background: 'var(--surface)',
          border: `1px solid ${invalid ? 'var(--error)' : 'var(--border)'}`,
          borderRadius: 'var(--r-md)',
          color: 'var(--text)',
          fontSize: 'var(--fs-body-lg)',
          appearance: 'none',
          WebkitAppearance: 'none',
          outline: 'none',
          cursor: 'pointer',
          ...style,
        }}
      >
        {children}
      </select>
      <ChevronDownIcon
        size={18}
        style={{
          position: 'absolute',
          right: 12,
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--text-muted)',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
});
